import BMRobertoR from '../assets/staff/businessmanager/robertoravazzolo.webp';
import BMPierluigiL from '../assets/staff/businessmanager/pierluigileoni.webp';
import BMStefanoDZ from '../assets/staff/businessmanager/stefanodalzovo.webp';
import BMGiacomoG from '../assets/staff/businessmanager/giacomogasperini.webp';
import BMPaoloDO from '../assets/staff/businessmanager/paolodellosso.webp';
import BMMaurizioG from '../assets/staff/businessmanager/mauriziogottardo.webp';
import BMPascalDC from '../assets/staff/businessmanager/pascaldicesare.webp';
import BMLauraP from '../assets/staff/businessmanager/laurapetetta.webp';
import BMGiuliaD from '../assets/staff/businessmanager/giuliadiambri.webp';
import BMRobertoA from '../assets/staff/businessmanager/robertoanelli.webp';
import BMLucaB from '../assets/staff/businessmanager/lucabrignoli.webp';
import BMAncaM from '../assets/staff/businessmanager/ancamihoc.webp';
import BMPaoloF from '../assets/staff/businessmanager/fada.webp';
import BMSilviaQ from '../assets/staff/businessmanager/quercioli.webp';
import BMAlessandroA from '../assets/staff/businessmanager/aquilanti.webp';
import BMStefanoB from '../assets/staff/businessmanager/stefanobonelli.webp';
import BMFilippoS from '../assets/staff/businessmanager/filippostrazzacapa.webp';
import BMMircoM from '../assets/staff/businessmanager/matteini.webp';
import BMStefanoC from '../assets/staff/businessmanager/cestele.webp';
import BMGabrielaF from '../assets/staff/businessmanager/falzone.webp';
import BMMarcoD from '../assets/staff/businessmanager/doni.webp';
import BMManuelaA from '../assets/staff/businessmanager/angeloni.webp';
import BMSimonaP from '../assets/staff/businessmanager/patera.webp';
import BMGiuseppeM from '../assets/staff/businessmanager/Giuseppe Moscati.webp';
import BMAlessioDC from '../assets/staff/businessmanager/Alessio De Clementi.webp';
import BMGiorgioL from '../assets/staff/businessmanager/Giorgio Locatelli.webp';
import BMCatiaV from '../assets/staff/businessmanager/CatiaValentini.webp';
import BMRamonA from '../assets/staff/businessmanager/RamonAgosti.webp';
import User from '../assets/staff/userimg.webp';
import VincenzoCoter from '../assets/staff/businessmanager/VincenzoCoter.webp'
import GiorgioLocatelli from '../assets/staff/businessmanager/GiorgioLocatelli.webp'
import IsabellaMartini from '../assets/staff/businessmanager/IsabellaMartini.webp' 
import SalvatoreCampanile from '../assets/staff/businessmanager/SalvatoreCampanile.webp'
import GiuliaPaoletti from '../assets/staff/businessmanager/GiuliaPaoletti.webp'
import FrancescaBerto from '../assets/staff/businessmanager/FrancescaBerto.webp'
import FedericoCeccarini from '../assets/staff/businessmanager/FedericoCeccarini.webp'





const people = [
    {
      name: 'Roberto Ravazzolo',
      role: 'Top Business Manager',
      imageUrl: BMRobertoR
    },
    {
        name: 'Pierluigi Leoni',
        role: 'Top Business Manager',
        imageUrl:BMPierluigiL
    },
    {
        name: 'Stefano Dal Zovo',
        role: 'Top Business Manager',
        imageUrl:BMStefanoDZ
    },
    {
        name: 'Giacomo Gasperini',
        role: 'Top Business Manager',
        imageUrl:BMGiacomoG
    },
    {
        name: "Paolo Dell'Osso",
        role: 'Top Business Manager',
        imageUrl:BMPaoloDO
    },
    {
        name: 'Anca Mihoc',
        role: 'Top Business Manager',
        imageUrl:BMAncaM
    },
    {
        name: 'Maurizio Gottardo',
        role: 'Business Manager',
        imageUrl:BMMaurizioG
    },
    {
        name: 'Pascal Di Cesare',
        role: 'Business Manager',
        imageUrl:BMPascalDC
    },
    {
        name: 'Laura Petetta',
        role: 'Business Manager',
        imageUrl:BMLauraP
    },
    {
        name: 'Giulia Diambri',
        role: 'Business Manager',
        imageUrl:BMGiuliaD
    },
    {
        name: 'Roberto Anelli',
        role: 'Business Manager',
        imageUrl:BMRobertoA
    },
    {
        name: 'Luca Brignoli',
        role: 'Business Manager',
        imageUrl:BMLucaB
    },
    
    {
        name: 'Paolo Fada',
        role: 'Business Manager',
        imageUrl:BMPaoloF
    },
    {
        name: 'Silvia Quercioli',
        role: 'Business Manager',
        imageUrl:BMSilviaQ
    },
    {
        name: 'Alessandro Aquilanti',
        role: 'Business Manager',
        imageUrl:BMAlessandroA
    },
    {
        name: 'Stefano Bonelli',
        role: 'Business Manager',
        imageUrl:BMStefanoB
    },
    {
        name: 'Filippo Strazzacapa',
        role: 'Business Manager',
        imageUrl:BMFilippoS
    },
    {
        name: 'Mirco Matteini',
        role: 'Business Manager',
        imageUrl:BMMircoM
    },
    {
        name: 'Stefano Cestele',
        role: 'Business Manager',
        imageUrl:BMStefanoC
    },
    {
        name: 'Gabriela Falzone',
        role: 'Business Manager',
        imageUrl:BMGabrielaF
    },
    {
        name: 'Marco Doni',
        role: 'Business Manager',
        imageUrl:BMMarcoD
    },
    {
        name: 'Manuela Angeloni',
        role: 'Business Manager',
        imageUrl:BMManuelaA
    },
    {
        name: 'Simona Patera',
        role: 'Business Manager',
        imageUrl:BMSimonaP
    },
    {
        name: 'Alessio De Clementi',
        role: 'Business Manager',
        imageUrl:BMAlessioDC
    },
    {
        name: 'Giuseppe Moscati',
        role: 'Business Manager',
        imageUrl:BMGiuseppeM
    },
    {
        name: 'Catia Valentini',
        role: 'Business Manager',
        imageUrl:BMCatiaV
    },
    {
        name: 'Ramon Agosti',
        role: 'Business Manager',
        imageUrl:BMRamonA
    },
    {
        name: 'Vincenzo Coter',
        role: 'Business Manager',
        imageUrl:VincenzoCoter
    },
    {
        name: 'Isabella Martini',
        role: 'Business Manager',
        imageUrl:IsabellaMartini
    },
    {
        name: 'Salvatore Campanile',
        role: 'Business Manager',
        imageUrl:SalvatoreCampanile
    },
    {
        name: 'Francesca Berto',
        role: 'Business Manager',
        imageUrl:FrancescaBerto
    },
    {
        name: 'Federico Ceccarini',
        role: 'Business Manager',
        imageUrl:FedericoCeccarini
    },
    {
        name: 'Giulia Paoletti',
        role: 'Business Manager',
        imageUrl:GiuliaPaoletti
    }
]
  
  export default function BusinessManager() {
    return (
        <>
            <ul
                role="list"
                className="mx-auto mt-20 grid max-w-2xl grid-cols-2 gap-x-8 gap-y-16 text-center sm:grid-cols-3 md:grid-cols-4 lg:mx-0 lg:max-w-none lg:grid-cols-5 xl:grid-cols-6"
            >
                {people.map((person) => (
                <li key={person.name} 
                data-aos="fade-in" data-aos-duration="1500"
                >
                    <img className="mx-auto h-24 w-24 rounded-full" src={person.imageUrl} alt={person.name} />
                    <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-neutral-200">{person.name}</h3>
                    <p className="text-sm leading-6 text-neutral-400">{person.role}</p>
                </li>
                ))}
            </ul>
        </>
    )
  }
  